// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 479) return "static/chunks/479-5323926993497b3b.js";
	if (chunkId === 134) return "static/chunks/134-4aa4a64bd12c8d33.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"418":"0da672af00c4803e","536":"8191c8fedb87d0ba"}[chunkId] + ".js";
};